module.exports = "/assets/data/5037b67d591ec7cbf7b656aca93db866-M6.data.json";